<template>
  <div style="clear: both;">

    <template v-if="readonly && modelValue">
      <v-text-field :label="startDateLabel" variant="underlined" :model-value="$filters.DateFilter(modelValue)" readonly dense 
        density="comfortable"></v-text-field>
    </template>

    <template v-if="readonly && !modelValue">
      <v-text-field :label="startDateLabel" variant="underlined" :model-value="$t('Immediately_On_Owner_Decision')" readonly dense 
        density="comfortable"></v-text-field>
    </template>

    <template v-if="!readonly">
      <v-menu
        v-model="formSettings.startDateMenu"
        :close-on-content-click="false"
        :nudge-right="40"
        transition="scale-transition"
        offset-y
        min-width="290px"
      >
        <template v-slot:activator="{ props }">
          <v-text-field
            :model-value="calculatedValue"
            :label="startDateLabel"
            prepend-icon="mdi-calendar"
            readonly
            v-bind="props"
            variant="underlined"
            :rules="rules.startDateRules"
            :error-messages="isStartDateAfterValidUntilDate"
            clearable
            dense
            density="comfortable"
            @click:clear.stop="clearStartDate()"
            :placeholder="moc.changeType.type.key === 'temporary' ? `${startDateLabel} ${$t('Is_Required')}` : null"
          ></v-text-field>
        </template>
        <template v-if="!readonly">
          <v-date-picker
            :model-value="selectedDate"
            hide-header
            no-title
            :min="minDateComputed"
            :max="maxDateComputed365"
            :readonly="readonly"
            v-on:update:model-value="updateValue"
          ></v-date-picker>
        </template>
      </v-menu>
    </template>
  </div>
</template>

<script>
import { FormStatus, Roles } from '@/common'
import { ChangeTypes } from '@/common/types'
import dateMixins from '@/mixins/dateMixins'
import moment from 'moment'
export default {
  emits: ['update:modelValue'],
  name: 'StartDateField',
  mixins: [dateMixins],
  data() {
    let self = this
    return {
      currentChangeType: {},
      formSettings: {
        startDateMenu: false
      },
      picker: null,
      rules: {
        startDateRules: [
          v => !!v || self.isPermanentChangeType() || ' ',
          v => self.dateEqualOrIsBefore(v, new Date(new Date().toDateString())) || this.$t('Date_Not_In_Past')
        ]
      }
    }
  },
  props: {
    modelValue: {
      type: String,
      default: ''
    },
    // modelValue: {
    //   type: Object,
    // },
    roles: {
      type: Array,
      default: null
    },
    fromModal: {
      type: Boolean,
      default: false
    },
    previousFormStatus: {
      type: Object
    },
    changeType: {
      type: Object
    },
    forceReadonly: {
      type: Boolean,
      default: false
    },
    moc: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    clearStartDate: function() {
      // this.$emit('input', null)
      this.$emit('update:modelValue', null)
    },
    dateEqualOrIsBefore(fromDate, toDate) {
      if (((this.moc.ownerDecision || {}).decision || {}).key === 'approved') {
        return true
      }

      if (fromDate && !isNaN(new Date(fromDate).getTime())) {
        return new Date(fromDate) >= new Date(toDate)
      }

      return true
    },
    isPermanentChangeType: function() {
      this.currentChangeType = this.changeType
      return (this.currentChangeType || {}).key === ChangeTypes.PERMANENT
    },
    updateValue: function(value) {
      this.formSettings.startDateMenu = false
      // let now = moment()
      // let now = Date()
      // console.log(`value ${value}`)
      // let date = now.format("YYYY-MM-DD")
      // console.log(`date ${date}`)
      // let time = this.getTimeLeftPad(now.hour()) + ':' + this.getTimeLeftPad(now.minute())  + ':' + this.getTimeLeftPad(now.second())
      // console.log(`time ${time}`)
      // console.log(`moment(date + ' ' + time).format() ${moment(date + ' ' + time).format()}`)
      // this.$emit('input', moment(value + ' ' + time).format())
      // this.$emit('update:modelValue', new Date(moment(date + ' ' + time).format("YYYY-MM-DD")))

      console.log(`StartDateField updateValue value ${value}`)
      // console.log(`time ${time}`)
      // let date = this.convertDateToString(value)
      // console.log(`date ${date}`)

      // console.log(`moment(value + ' ' + time).format() ${moment(date + ' ' + time).format()}`)
      // this.$emit('update:modelValue', moment(date + ' ' + time).format())
      // this.$emit('update:modelValue', now.toLocaleString())
      // this.$emit('update:modelValue', now)
      let now = moment()
      let time = now.hour() + ':' + now.minute() + ':' + now.second()

      let dateString = value.getFullYear() + '-' + this.getTimeLeftPad(value.getMonth() + 1)  + '-' + this.getTimeLeftPad(value.getDate())
      console.log(`moment(dateString + ' ' + time).format() ${moment(dateString + ' ' + time).format()}`)

      // this.$emit('update:modelValue', value)
      // this.$emit('update:modelValue', dateString)
      this.$emit('update:modelValue', moment(dateString + ' ' + time).format())
    },
    getTimeLeftPad: function(number){
      // console.log(`number ${number}`)
      if(number.length < 2){
        return '0' + number
      }
      return number
    }
  },
  computed: {
    calculatedValue() {
      if (!this.formattedDate && this.moc.status.value === FormStatus.properties[FormStatus.SENTBACKFORCORRECTIONS].value) {
        return this.$t('Immediately_On_Owner_Decision')
      }
      console.log(`this.formattedDate ${this.formattedDate}`)
      // return this.formattedDate ? this.$options.filters.date(this.formattedDate) : ''
      return this.formattedDate ? this.$filters.DateFilter(this.formattedDate) : ''
      // return this.formattedDate ? this.formattedDate.toString() : ''
    },
    isStartDateAfterValidUntilDate() {
      // here we only care if the start date is before the valid unitl date before sumbit
      if (
        this.moc.status.value === FormStatus.properties[FormStatus.NEW].value ||
        this.moc.status.value === FormStatus.properties[FormStatus.DRAFT].value
      ) {
        if (this.moc.dates.validUntil && this.moc.dates.start) {
          if (new Date(this.moc.dates.start) > new Date(this.moc.dates.validUntil)) {
            return this.$t('StartDate_Before_ValidUnitDate')
          }
          return null
        }
        return null
      }
      return null
    },
    readonly: function() {
      if (this.forceReadonly) {
        return true
      }
      switch (this.moc.status.value) {
        case FormStatus.properties[FormStatus.NEW].value:
          if (
            this.roles.includes(Roles.properties[Roles.INITIATOR].value) ||
            this.roles.includes(Roles.properties[Roles.COINITIATOR].value)
          ) {
            return false
          }
          break
        case FormStatus.properties[FormStatus.DRAFT].value:
          if (
            this.roles.includes(Roles.properties[Roles.INITIATOR].value) ||
            this.roles.includes(Roles.properties[Roles.COINITIATOR].value)
          ) {
            return false
          }
          break
        case FormStatus.properties[FormStatus.SUBMITTED].value:
          if (
            this.roles.includes(Roles.properties[Roles.INITIATOR].value) ||
            this.roles.includes(Roles.properties[Roles.COINITIATOR].value)
          ) {
            return true
          }
          break
        case FormStatus.properties[FormStatus.SENTBACKFORCORRECTIONS].value:
          if (
            this.roles.includes(Roles.properties[Roles.INITIATOR].value) ||
            this.roles.includes(Roles.properties[Roles.COINITIATOR].value)
          ) {
            return false
          }
          break
        case FormStatus.properties[FormStatus.PENDINGOWNERDECISION].value:
          if (this.roles.includes(Roles.properties[Roles.OWNER].value) && this.fromModal) {
            return false
          }
          break
        case FormStatus.properties[FormStatus.BEINGREVISED].value:
          if (
            (this.previousFormStatus.value === FormStatus.properties[FormStatus.AVAILABLEFORDECISION].value ||
              this.previousFormStatus.value === FormStatus.properties[FormStatus.PENDINGOWNERDECISION].value) &&
            (this.roles.includes(Roles.properties[Roles.INITIATOR].value) ||
              this.roles.includes(Roles.properties[Roles.COINITIATOR].value) ||
              this.roles.includes(Roles.properties[Roles.OWNER].value))
          ) {
            return false
          }
          break
        default:
          return true
      }
      return true
    },
    startDateLabel: function() {
      return this.$t('Start_Date_Proposed')
    },
    selectedDate: function() {
      if (!this.modelValue) return null
      // return this.formatDate(this.modelValue)
      // return this.formatDate(this.modelValue)
      // return this.modelValue
      return new Date(this.modelValue)
    }
  },
  watch: {
    changeType(val) {
      console.log(`StartDateField changeType`)
      this.currentChangeType = val
    }
  }
}
</script>

<style scoped></style>
